export type InviteData = {
  uid: string;
  name: string;
  email: string;
  createdDate: Date;
}

export type SerializedInviteData = {
  uid: string;
  name: string;
  email: string;
  createdDate: number;
}

export const inviteTransform = (val: any): InviteData => {
  // react-firebase-hooks calls transforms with `null` when the snapshot has no data.
  if (val == null) return val as unknown as InviteData;
  return {
    ...val,
    createdDate: new Date(val.createdDate),
  };
}
